import { HeroSection } from './HeroSection';
import { HouseSection } from './HouseSection';
import { SliderSection } from './GoodsSlider/SliderSection';

export const WelcomePage = () => {
  return (
    <main className="min-h-screen">
      <HeroSection />
      <SliderSection />
      <HouseSection />
    </main>
  );
};
